// extracted by mini-css-extract-plugin
export default {"mandatoryText":"styles_mandatoryText__LOgcT"};